module.exports = __webpack_public_path__ + "img/technical1.98da3a11.png";